import styles from './EmptyBox.module.scss';

export const EmptyBox = ({ message }) => {
  return (
    <div className={styles.emptyBox}>
      <span className={styles.message}>{message}</span>
    </div>
  );
};
